import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  pn,
} from "@compass/core";
import { ListBeProperty } from "components";
import { SortObject, TextingQueueListDto, TextingQueueListResource } from "generated/openApi";
import { useDateTime } from "hooks";
import { useNavigate } from "react-router-dom";
import { TextingStatusChip } from "../TextingStatusChip";
import { textingQueueDetailPageRoute } from "../TextingQueueDetailPage/TextingQueueDetailPage";

export const ScheduledTextsTable = (props: {
  tableContainerRef: React.RefObject<HTMLDivElement>;
  scheduledTexts: TextingQueueListDto[];
  resource: TextingQueueListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const properties = props.resource.properties || [];
  const formatDateTime = useDateTime();
  const navigate = useNavigate();

  const columnHeader = (propertyName: keyof TextingQueueListDto) => (
    <ListBeProperty
      listProperty={properties.find((property) => property.propertyName === pn<TextingQueueListDto>(propertyName))}
      searchFocused={props.searchFocused}
      sortObjects={props.sortObjects}
      onChange={props.sort}
    />
  );

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>{columnHeader("scheduledDate")}</TableCell>
            <TableCell>{columnHeader("name")}</TableCell>
            <TableCell>{columnHeader("personType")}</TableCell>
            <TableCell>{columnHeader("sent")}</TableCell>
            <TableCell>{columnHeader("status")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.scheduledTexts.map((scheduledText) => (
            <TableRow
              key={scheduledText.id}
              onClick={() => navigate(textingQueueDetailPageRoute.getPath({ id: scheduledText.id }))}
            >
              <TableCell>{formatDateTime(scheduledText.scheduledDate)}</TableCell>
              <TableCell>{scheduledText.name}</TableCell>
              <TableCell>{scheduledText.personType}</TableCell>
              <TableCell>{scheduledText.sent}/{scheduledText.total}</TableCell>
              <TableCell>
                {scheduledText.status && <TextingStatusChip status={scheduledText.status} />}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
